import { Component } from 'react';
import { payInvoice } from './query';
import { showMessage } from '../../helpers/showMessage';
import Loading from '../../components/Loading';

const TEXT_COLOR = 'rgb(51 177 165)';

const BUTTON_STYLE = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    border: 'none',
    borderRadius: '25px',
    backgroundColor: 'rgb(216 255 254)',
    color: TEXT_COLOR,
    padding: '6px 12px',
    fontSize: '12px',
    fontWeight: 600,
    cursor: 'pointer',
};

const BUTTON_STYLE_HOVER = {
    ...BUTTON_STYLE,
    backgroundColor: 'rgb(190 245 243)',
};

// Give the success toast a moment on screen before the reload (needed to refresh the invoice
// list) tears the page down.
const RELOAD_DELAY_MS = 1200;

class PayNowButton extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: false, hovered: false };
        this.onPay = this.onPay.bind(this);
        this.onMouseEnter = () => this.setState({ hovered: true });
        this.onMouseLeave = () => this.setState({ hovered: false });
    }

    async onPay() {
        this.setState({ loading: true });
        try {
            const response = await payInvoice(this.props.invoiceId);
            if (response.status === 200) {
                showMessage(this.props.t('invoices.pay_success'), 'success');
                window.setTimeout(() => window.location.reload(), RELOAD_DELAY_MS);
                return;
            }
            const data = await response.json();
            showMessage(data?.detail || this.props.t('invoices.pay_error'), 'error');
            this.setState({ loading: false });
        } catch (err) {
            showMessage(this.props.t('invoices.pay_error'), 'error');
            this.setState({ loading: false });
        }
    }

    render() {
        if (this.state.loading) return <Loading span onlyPreloader fontSize="16px" />;
        return (
            <button
                type="button"
                style={this.state.hovered ? BUTTON_STYLE_HOVER : BUTTON_STYLE}
                onClick={this.onPay}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                <i className="icofont-credit-card" style={{ fontSize: '16px', color: TEXT_COLOR }}></i>
                {this.props.t('invoices.pay_now')}
            </button>
        );
    }
}

export default PayNowButton;
